import type { SignalRConfig } from './signalRconfig';
import { type App, inject } from 'vue';
import { SignalRService } from './signalRservice';
import { SignalRSymbol } from './signalRsymbols';
import { HubConnectionBuilder } from '@microsoft/signalr';

export interface VueSignalR {
    install(app: App): void;
}

/**
 * Creates a Vue-SignalR instance to be used by the application.
 * The connection is automatically started unless the `options` parameter is left empty.
 * @param options Configuration options for building the HubConnection. When left empty, the {@link SignalRService.init|init} method must be called prior to start.
 */
export function createSignalR(options: SignalRConfig = { url: '' }): VueSignalR {
    return {
        async install(app: App): Promise<void> {
            const service = new SignalRService(options, new HubConnectionBuilder());
            app.provide(SignalRSymbol, service);

            if (service.connection) {
                await service.start();
            }
        }
    };
}

/** Inject the SignalR service */
export function useSignalR(): SignalRService {
    const signalr = inject(SignalRSymbol);
    if (!signalr) {
        throw new Error('Failed to inject SignalR');
    }

    return signalr;
}
